import { useEffect, useState, useCallback } from 'react';

import AtividadeService from '@services/AtividadeService';

const useAtividades = () => {
    const [ data, setData ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const fetchData = useCallback(() => {
        setLoading(true);

        AtividadeService.listar()
            .then(res => setData(res.data.content.map(a => ({ value: a.id, label: a.descricao }) )))
            .catch(err => setError(err))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => fetchData(), [fetchData]);

    return { data, loading, error };
}

export default useAtividades;